import { consiglioNazionaleMilano2025 } from './consiglio-nazionale-milano-2025';
import { consiglioNazionaleRoma2025 } from './consiglio-nazionale-roma-2025';
import { consiglioNazionaleNapoli2024 } from './consiglio-nazionale-napoli-2024';
import { ringraziamentiConsiglioMilano2025 } from './ringraziamenti-consiglio-milano-2025';
import { pescaraNuovaSegreteria2025 } from './pescara-nuova-segreteria-2025';
import { audizioneCamera2025 } from './audizione-camera-2025';
import { compleannoSegretario2025 } from './compleanno-segretario-2025';
import { incontroMitCapitanerie2025 } from './incontro-mit-capitanerie-2025';
import { attenzioneTruffe } from './attenzione-truffe';
import { reatDecreto } from './reat-decreto';
import { emailEzmlm } from './email-ezmlm';
import { truffaTriangolazione } from './truffa-triangolazione';
import { interventoCameraSIMCE } from './intervento-camera-simce';

// Tipo per gli articoli statici
export interface StaticArticle {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  body: string;
  featuredImage: string;
  category: {
    id: string;
    name: string;
    slug: string;
    color?: string;
  };
  tags: string[];
  author: {
    id: string;
    username: string;
    profile: {
      firstName: string;
      lastName: string;
      fullName: string;
    };
  };
  status: 'PUBLISHED' | 'DRAFT' | 'ARCHIVED';
  visibility: 'PUBLIC' | 'MEMBERS' | 'ADMIN';
  publishedAt: string;
  createdAt: string;
  updatedAt: string;
  metadata: {
    views: number;
    likeCount: number;
    shares: number;
  };
  readingTime: number;
}

// Array di tutti gli articoli statici (ordinati dal più recente al più vecchio)
export const staticArticles: StaticArticle[] = [
  truffaTriangolazione,            // 29 ottobre 2025
  consiglioNazionaleRoma2025,      // 15 settembre 2025
  incontroMitCapitanerie2025,      // 8 luglio 2025
  compleannoSegretario2025,        // 8 luglio 2025
  pescaraNuovaSegreteria2025,      // 5 luglio 2025
  audizioneCamera2025,             // 2 luglio 2025
  reatDecreto,                     // 19 giugno 2025
  ringraziamentiConsiglioMilano2025, // 26 maggio 2025
  consiglioNazionaleMilano2025,    // 25 maggio 2025
  emailEzmlm,                      // 26 maggio 2025
  attenzioneTruffe,                // 18 maggio 2025
  interventoCameraSIMCE,           // 15 gennaio 2025
  consiglioNazionaleNapoli2024,    // 24 novembre 2024
];

// Funzioni helper per gestire gli articoli statici

/**
 * Ottieni tutti gli articoli statici
 */
export const getAllStaticArticles = (): StaticArticle[] => {
  return staticArticles;
};

/**
 * Ottieni un articolo statico per slug
 */
export const getStaticArticleBySlug = (slug: string): StaticArticle | undefined => {
  return staticArticles.find(article => article.slug === slug);
};

/**
 * Ottieni un articolo statico per ID
 */
export const getStaticArticleById = (id: string): StaticArticle | undefined => {
  return staticArticles.find(article => article.id === id);
};

/**
 * Ottieni articoli statici per categoria
 */
export const getStaticArticlesByCategory = (categorySlug: string): StaticArticle[] => {
  return staticArticles.filter(article => article.category.slug === categorySlug);
};

/**
 * Ottieni articoli statici per tag
 */
export const getStaticArticlesByTag = (tag: string): StaticArticle[] => {
  return staticArticles.filter(article => article.tags.includes(tag));
};

/**
 * Cerca articoli statici per testo
 */
export const searchStaticArticles = (searchTerm: string): StaticArticle[] => {
  const term = searchTerm.toLowerCase();
  return staticArticles.filter(article => 
    article.title.toLowerCase().includes(term) ||
    article.excerpt.toLowerCase().includes(term) ||
    article.body.toLowerCase().includes(term) ||
    article.tags.some(tag => tag.toLowerCase().includes(term))
  );
};

/**
 * Ottieni articoli statici ordinati per data (più recenti prima)
 */
export const getStaticArticlesSortedByDate = (): StaticArticle[] => {
  return [...staticArticles].sort((a, b) => 
    new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
  );
};

/**
 * Ottieni articoli statici più popolari (per visualizzazioni)
 */
export const getPopularStaticArticles = (limit: number = 5): StaticArticle[] => {
  return [...staticArticles]
    .sort((a, b) => b.metadata.views - a.metadata.views)
    .slice(0, limit);
};

export default staticArticles;

